import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react'
import QuantumCircuit from "quantum-circuit"
import {
  Container,
  Segment,
  Header,
  List,
  Icon,
  Button,
  Label,
  Grid,
  Divider,
} from 'semantic-ui-react'

const delay = ms => new Promise(res => setTimeout(res, ms));

function App() {
  // Generated in ⟨Quantum|Copilot⟩ and modified
  const [ circuit, setCircuit ] = useState(new QuantumCircuit(2))
  const [ cregs, setCregs ] = useState(null)
  const [ source, setSource ] = useState('images/Glitch.png')
  useEffect(() => {
    circuit.createCreg("c", 2);
    circuit.appendGate("h", 0, {});
    circuit.appendGate("cx", [0,1], {});
    circuit.addMeasure(0, "c", 0);
    circuit.addMeasure(1, "c", 1);
    circuit.run();

    setCregs(circuit.cregsAsString())
    console.log('cregs:', cregs)

    circuit.run();
    const localCregs = circuit.cregsAsString()
    console.log('localCregs:', localCregs)

    if (localCregs.includes('00')) {
      setSource('images/catTTY.png')
    } else if (localCregs.includes('11')) {
      setSource('images/catsTTY.png')
    } else {
      console.warn('neither 00 nor 11')
    }

    (async () => {
      await delay(5000);
      circuit.run();
      const secondCregs = circuit.cregsAsString()
      console.log('secondCregs:', secondCregs)

      circuit.run();
      const thirdCregs = circuit.cregsAsString()
      console.log('thirdCregs:', thirdCregs)
      if (secondCregs.includes('00')) {
        if (thirdCregs.includes('00')) {
          setSource('images/catsTTY.png')
        } else if (thirdCregs.includes('11')) {
          setSource('images/catTTY.png')
        } else {
          console.warn('2. neither 00 nor 11')
        }
      } else if (secondCregs.includes('11')) {
        if (thirdCregs.includes('00')) {
          setSource('images/Glitch.png')
        } else if (thirdCregs.includes('11')) {
          setSource('images/GlitchAndDirevative.png')
        } else {
          console.warn('3. neither 00 nor 11')
        }
      } else {
        console.warn('4. neither 00 nor 11')
      }
    })()
  }, [circuit])

  return (
    <>
      <div className="App">
        <header className="App-header">
          <a
            className="App-catTTY"
            href="/chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            catTTY's
          </a>
          <a
            className="App-link"
            href="/chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            Quantum GPT
          </a>
          <a
            href="/chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={source} className={cregs === null ? "App-logo" : (cregs.includes('00') ? "App-logo00" : (cregs.includes('11') ? "App-logo11" : "App-logo")) } alt="logo" />
          </a>
          <a
            href="/chat"
            target="_blank"
            rel="noopener noreferrer"
            style={{ marginTop: '1em', marginBottom: '1em' }}
          >
            Ultimate Guide to Quantum Computing for Beginners
          </a>
          <Button as='div' labelPosition='right'>
            <Button basic color='blue' as='a'>
              <a
                href="https://womanium.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name='external alternate' />
                Womanium
              </a>
            </Button>
            <Label as='a' basic color='blue' pointing='left'>
              <a
                href="https://womanium.org/Quantum/Program"
                target="_blank"
                rel="noopener noreferrer"
              >
                Global Quantum Project Winner
              </a>
            </Label>
          </Button>
        </header>
      </div>

      <Container>
        <Header as='h3' attached='top'>
          <Icon name='rocket' />
          Welcome to Quantum GPT!
        </Header>
        <Segment color='red' attached>
          <p>
            Are you fascinated by the intriguing world of quantum computing but find it difficult to grasp the fundamentals?
          </p>
          <p>
            Look no further!
            Quantum GPT is a user-friendly web application designed specifically for beginners like you.
          </p>
          <p>
          With our powerful GPT (Generative Pre-trained Transformer) API integration, we make learning quantum computing a breeze.
          </p>
        </Segment>

        <Header as='h3' attached='top'>
          <Icon name='tag' />
          What is Quantum GPT?
        </Header>
        <Segment color='orange' attached>
          Quantum GPT is an innovative web application that serves as your ultimate guide to understanding the basics of quantum computing. Our platform harnesses the power of GPT, a cutting-edge AI language model, to provide you with an immersive and interactive learning experience. Whether you have a scientific background or not, Quantum GPT is here to demystify the complexities of quantum computing and help you build a strong foundation.
        </Segment>

        <Header as='h3' attached='top'>
          <Icon name='list' />
          Why Choose Quantum GPT?
        </Header>
        <Segment color='yellow' attached>
          <List>
            <List.Item as='a'>
              <Icon name='window restore' />
              <List.Content>
                <List.Header>
                  Beginner-Friendly Interface
                </List.Header>
                <List.Description>
                  Our user-friendly interface is specifically designed for individuals with little to no prior knowledge of quantum computing. You don't need to be an expert to embark on your quantum journey with Quantum GPT.
                </List.Description>
              </List.Content>
            </List.Item>
            <List.Item as='a'>
              <Icon name='cubes' />
              <List.Content>
                <List.Header>
                  GPT API Integration
                </List.Header>
                <List.Description>
                  By leveraging the power of GPT, Quantum GPT provides accurate and comprehensive explanations of complex quantum computing concepts. Our AI-powered model generates easy-to-understand explanations, making it easier for beginners to learn and explore.
                </List.Description>
              </List.Content>
            </List.Item>
            <List.Item as='a'>
              <Icon name='eye' />
              <List.Content>
                <List.Header>
                  Real-World Examples
                </List.Header>
                <List.Description>
                  Quantum GPT goes beyond theory and provides real-world examples to help you see the practical applications of quantum computing. Our platform bridges the gap between abstract concepts and their real-life implications.
                </List.Description>
              </List.Content>
            </List.Item>
          </List>
        </Segment>

        <Header as='h3' attached='top'>
          <Icon name='comments' />
          How Does Quantum GPT Work?
        </Header>
        <Segment color='green' attached>
          Using Quantum GPT is as simple as signing up and accessing our platform. Once you're in, you can explore the various learning modules tailored to your level of knowledge. Dive into the fascinating world of quantum computing through chatting with AI. Our GPT-powered AI model will provide you with detailed explanations and answers to your queries, ensuring a seamless learning experience.
        </Segment>

        <Header as='h3' attached='top'>
          <Icon name='paper plane' />
          Embark on Your Quantum Journey Today!
        </Header>
        <Segment color='blue' attached>
          <p>
          Don't let the complexities of quantum computing intimidate you. Quantum GPT is here to make your learning journey enjoyable and accessible. Whether you're a student, a professional, or simply curious about this revolutionary field, Quantum GPT has everything you need to get started.
          </p>
          <p>
          Join us today and unlock the limitless possibilities of quantum computing!
          </p>
          <a
            className="App-link"
            href="/chat"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button fluid as='a' primary>
            Join
            </Button>
          </a>
        </Segment>
      </Container>

      <Segment inverted vertical style={{ padding: '5em 0em' }}>
        <Container>
          <Grid divided inverted stackable>
            <Grid.Row>
              <Grid.Column width={3}>
                <Header inverted as='h4' content='About' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='mailto:admin@vuics.com'>
                      Contact Us
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://www.linkedin.com/showcase/quantum-gpt/' target='_blank' rel='noopener noreferrer'>
                      Follow on LinkedIn
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://www.youtube.com/playlist?list=PLXkNXBn6_PqwI0pC3VumUY4UpZYfHaG7y' target='_blank' rel='noopener noreferrer'>
                      Subscribe on YouTube
                    </a>
                  </List.Item>
                  {/*
                  <List.Item as='a'>
                    <a href='https://www.producthunt.com/posts/quantum-copilot' target='_blank' rel='noopener noreferrer'>
                      Upvote on ProductHunt
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/category/quantum-copilot' target='_blank' rel='noopener noreferrer'>
                      Knowledge Base
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.tawk.help/article/quantum-copilot-faq' target='_blank' rel='noopener noreferrer'>
                      FAQ
                    </a>
                  </List.Item>
                  */}
                </List>
              </Grid.Column>
              <Grid.Column width={5}>
                <Header inverted as='h4' content='Services' />
                <List link inverted>
                  <List.Item as='a'>
                    <a href='https://qc.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum Copilot
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://quantum-gpt.vuics.com/' target='_blank' rel='noopener noreferrer'>
                      Quantum GPT
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://vuics.com' target='_blank' rel='noopener noreferrer'>
                      Voice User Interfaces
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <Divider />
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://cs.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Contract Smarter
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://jf.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Joke Funnier
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qt.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Quantum Trading Fund
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://hc.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Hypno-Coaching
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qm.vuics.com' target='_blank' rel='noopener noreferrer'>
                      TchaiQovsky: Quantum Music
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://db.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Your Own Decentalized Bank
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://sf.vuics.com' target='_blank' rel='noopener noreferrer'>
                      Open-Source: Survival For
                    </a>
                  </List.Item>
                  <List.Item as='a'>
                    <Divider />
                  </List.Item>
                  <List.Item as='a'>
                    <a href='https://qcohorte.org/' target='_blank' rel='noopener noreferrer'>
                      Q cohorté
                    </a>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={7}>
                <List link inverted>
                  <List.Item as='a'>
                    catTTY's Quantum GPT Heroes for Kids & Adults
                  </List.Item>
                  <List.Item as='a'>
                    © 2023 catTTY Quantum GPT. All rights reserved.
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
      <div className="App">
        <header className="App-footer">
        <Segment placeholder inverted>
          <Grid columns={2} relaxed='very' stackable>
            <Grid.Column>
              <img src={cregs?.includes('00') ? 'images/JatinRana_Award.png' : 'images/ArtemArakcheev_Award.png'} className={cregs === null ? "App-logo" : (cregs.includes('00') ? "App-logo00" : (cregs.includes('11') ? "App-logo11" : "App-logo")) } alt="Badges awarded to Jatin Rana or/and Artem Arakcheev by Womanium as Quantum Start-Up Potential Prize" />
            </Grid.Column>
            <Grid.Column verticalAlign='middle'>
              <img src={cregs?.includes('11') ? 'images/JatinRana_Award.png' : 'images/ArtemArakcheev_Award.png'} className={cregs === null ? "App-logo" : (cregs.includes('00') ? "App-logo00" : (cregs.includes('11') ? "App-logo11" : "App-logo")) } alt="Badges awarded to Jatin Rana or/and Artem Arakcheev by Womanium as Quantum Start-Up Potential Prize" />
            </Grid.Column>
          </Grid>

          <Divider vertical>Our Awards</Divider>
        </Segment>
        </header>
      </div>
    </>
  );
}

export default App;
